import { Modal, Popover } from '@umu/umu-design';
import React from 'react';
import TipsIcon from '../../images/icon/tips.png';
import './index.scss';
import { isDesktop } from '@umu/umu-ua';
import { lang } from '@umu/ukit-lang';

interface IProps {
    text: string;
    img: string;
}
export const EmigrateCardTipPopover = (props: IProps) => {
    if (isDesktop) {
        return (
            <Popover
                id="emigrateCardTipPopover"
                content={
                    <div className="emigratePopover">
                        <div className="em-popover-header">{props.text}</div>
                        <div className="img">
                            <img src={props.img} alt="" />
                        </div>
                    </div>
                }
                placement="bottom"
                title={null}
                trigger="hover"
            >
                <img src={TipsIcon} alt="" className="emigrateTipIcon" />
            </Popover>
        );
    } else {
        return (
            <img
                src={TipsIcon}
                alt=""
                className="emigrateTipIcon"
                onClick={() => {
                    Modal.confirm({
                        title: '',
                        width: 320,
                        className: 'emigrateCardTipModal',
                        content: (
                            <div className="m emigratePopover">
                                <div className="em-popover-header">{props.text}</div>
                                <div className="img">
                                    <img src={props.img} alt="" />
                                </div>
                            </div>
                        ),
                        cancelText: '',
                        centered: true,
                        okText: lang('知道了'),
                        closable: false,
                    });
                }}
            />
        );
    }
};
